import ApiClient from '@softwaredev_cegeka/api-client'

class AuthApi extends ApiClient {
    static BASE_URL = '/api/auth'

    deleteImpersonator() {
        return this.client.delete('/impersonator', {
            params: {
                organization_only: true,
            },
        })
    }

    postImpersonator(params, cancelId = null) {
        const { organisationId } = params

        if (!organisationId) {
            return Promise.reject(
                'Invalid params: Please provide an organisationId.'
            )
        }
        return this.client.post(
            '/impersonator',
            {
                organization_id: organisationId,
            },
            cancelId
        )
    }
}

export { AuthApi }
